import Vue from 'vue'
import Vuex from 'vuex'
import {settings as routerSettings, default as router} from '../router'
import VueLocalStorage from 'vue-localstorage'
import storageHelper from 'storage-helper'
import http from 'vue-resource'

Vue.use(VueLocalStorage, {
  name: 'ls'
})

Vue.use(Vuex)
Vue.use(http)

// the root, initial state object
const storageHelperExt = {
  get (state, arg) {
    let b = storageHelper.getItem(state)
    return JSON.parse(b)
  },
  set (state, arg) {
    let a = JSON.stringify(arg)
    storageHelper.setItem(state, a)
  }
}

const state = Object.assign({
  role: null,
  shop: null,
  token: null,
  logged: 0,
  dispatchSettings: null
}, storageHelperExt.get('state'))

// define the possible mutations that can be applied to our state
const mutations = {
  LOGIN (state, payload) {
    state.logged = 1
    state.role = payload.role
    state.token = payload.token
    if (payload.role === 'shop' && typeof payload.shop !== 'undefined') {
      state.shop = payload.shop
    }
    storageHelperExt.set('state', state)
  },
  LOGOUT (state) {
    state.logged = 0
    state.role = null
    state.token = null
    storageHelperExt.set('state', state)
  },
  UPDATE_DISPATCH_SETTINGS (state, payload) {
    state.dispatchSettings = payload
    storageHelperExt.set('state', state)
  },
  SHOP (state, shop) {
    state.shop = shop
    storageHelperExt.set('state', state)
  },
  REFRESH_TOKEN (state, payload) {
    state.token = payload
    storageHelperExt.set('state', state)
  }
}
const actions = {
  logout (context) {
    console.log(context)
    Vue.http.post(routerSettings.getApiRoute('logout'), {}, {headers: {'x-auth-token': context.getToken}})
    context.commit('LOGOUT')
    context.commit('SHOP', null)
    router.push({name: 'Login'})
  }
}
const getters = {
  logged (state) {
    return state.logged
  },
  getDispatchSettings (state) {
    return state.dispatchSettings
  },
  getShop (state) {
    return state.shop
  },
  getToken (state) {
    return state.token
  }
}

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js